import { render, staticRenderFns } from "./detailApp.vue?vue&type=template&id=4b83d281&scoped=true&"
import script from "./detailApp.vue?vue&type=script&lang=js&"
export * from "./detailApp.vue?vue&type=script&lang=js&"
import style0 from "./detailApp.vue?vue&type=style&index=0&id=4b83d281&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b83d281",
  null
  
)

export default component.exports